import React from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export default function AddOwner() {
  return (
    <DashboardLayout><DashboardNavbar></DashboardNavbar></DashboardLayout>
  )
}
